import Component from '../Component';
import React from 'react';
import DbInfo from '../../dbinfo';
import immutable from 'immutable';
import Radio from './IconRadio';
import {OverlayTrigger, Popover} from 'react-bootstrap';


export default class RadioList extends Component {

	handleClick(val, item) {
		if (this.props.onChange) {
			this.props.onChange(val);
		}
		if (this.props.onBlur) {
			this.props.onBlur(val)
		}
	}

	render() {
		const options = this.props.options.asArray ? this.props.options.asArray() : this.props.options;
		const items = options.map((item) => {
			const value = this.props.value == item.id;
			let comp = <span className="multi-checkbox-label" style={{color: item.color}}>{item.title}</span>;
			if (item.tooltip) {
				comp = <OverlayTrigger placement='top' overlay={<Popover id="info">{item.tooltip}</Popover>}>{comp}</OverlayTrigger>
			}
			return <label key={item.id} onClick={() => this.handleClick(item.id, item)}>
					<Radio value={value} color={item.color} /> {comp}
				</label>
		});

		return (
			<span className="multi-checkbox">{items}</span>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/Form/RadioList.js